import indexedDBHelper from '@/helper/indexedDBHelper';
import { useRootStore } from '@/store/root';

const getKey = function (type, fullPath) {
  const splittedPath = fullPath.split('/');
  return type === 'company'
    ? splittedPath.slice(-4).join('/')
    : splittedPath.at(-1);
};

const routes = async () => {
  // ATTENTION: this is the major Init entry for IndexedDB. Move wisely.
  const data = await indexedDBHelper.getData('meta');
  const { modules } = data;
  if (!modules)
    return new Promise((resolve) =>
      resolve([
        {
          path: '/:pathMatch(.*)*',
          redirect: (to) => ({
            name: 'login',
            query: { redirect: to.fullPath },
          }),
        },
      ]),
    );

  return Object.keys(modules).map((type) => ({
    path: type,
    meta: {
      public: false,
    },
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: '',
        redirect: '/', // Redirect if no id
        name: type,
      },
      {
        path: type === 'company' ? ':id/:vkorg/:vtweg/:spart' : ':id',
        name: `${type}.detail`,

        beforeEnter: async ({ fullPath }, from, next) => {
          const key = getKey(type, fullPath);

          useRootStore().parentObject = { type, key };

          next();
        },
        component: () => import('@/views/detail/Detail/Detail'),
        props: ({ fullPath }) => ({ type, objectKey: getKey(type, fullPath) }),
      },
    ],
  }));
};

export default await routes();
